import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import Button from "../../components/ui/Button";
import Card from "../../components/ui/Card";
import EmptyState from "../../components/ui/EmptyState";

const NotFound = () => (
  <Card padded={false} className="anim-in">
    <EmptyState
      tone="violet"
      icon={<Compass size={24} />}
      title="Page not found"
      description="That link does not lead anywhere in the admin. It may have moved, or the app it pointed at was deleted."
      action={
        <Button as={Link} to="/" size="sm">
          Back to dashboard
        </Button>
      }
    />
  </Card>
);

export default NotFound;
